@if (imageDisplay === 'link') {
  <div id="photo-camera">
    @if (imageName !== null) {
      <div class="photo-camera-distribution">
        @if (hasCurrentImage()) {
          <button class="image-preview-button" type="button" (click)="viewImage()" aria-label="Ver archivo subido">
            <i class="fa fa-picture-o icon-picture" aria-hidden="true"></i>
          </button>
        }

        @if (formType < 3) {
          <app-reactive-camera (sendCameraFile)="uploadFile($event)"></app-reactive-camera>
        }
      </div>
    }
  </div>
} @else if (imageDisplay === 'header') {
  <div class="reactive-upload-header-action">
    <input type="file" #adjuntarFoto (change)="uploadFile($event)" class="d-none" [accept]="accept" />

    @if (hasCurrentImage()) {
      <button class="btn btn-link" type="button" (click)="viewImage()">
        <i [class]="isImageUpload() ? 'fa fa-picture-o' : 'fa fa-file-text-o'" aria-hidden="true"></i>
        <span>{{ getViewLabel() }}</span>
      </button>
    }

    @if (formType < 3) {
      <button type="button" class="btn btn-primary" [disabled]="isUploading" (click)="adjuntarFoto.click()">
        @if (isUploading) {
          <i class="fa fa-spinner fa-spin me-2" aria-hidden="true"></i>
        }
        {{ buttonLabel }}
      </button>
    }
  </div>
} @else {
  <div class="col-sm-2 mb-5">
    <input type="file" #adjuntarFoto (change)="uploadFile($event)" class="d-none" [accept]="accept" />

    <div class="d-flex justify-content-center">
      <button type="button" class="btn upload-image-button" [disabled]="isUploading" (click)="adjuntarFoto.click()">
        @if (isUploading) {
          <i class="fa fa-spinner fa-spin me-2" aria-hidden="true"></i>
        }
        {{ buttonLabel }}
      </button>
    </div>

    @if (showPreview && imageModel[imageName ?? '']) {
      <img
        class="uploaded-image-preview"
        [src]="getInlinePreviewUrl()"
        alt="Foto Producto">
    }
  </div>
}

@if (uploadError) {
  <div class="reactive-upload-error" role="alert">
    <span>{{ uploadError }}</span>
    <button type="button" class="reactive-upload-error-close" (click)="clearUploadError()" aria-label="Cerrar error">
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
  </div>
}
